import { ProtocolIcon } from './chunk-7K5EYODF.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ProtocolCardTitle({ protocolId, icon, label }) {
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
    /* @__PURE__ */ jsx(ProtocolIcon, { protocolId, icon }),
    /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: label })
  ] });
}

export { ProtocolCardTitle };
//# sourceMappingURL=chunk-BWHZ7CRB.js.map
//# sourceMappingURL=chunk-BWHZ7CRB.js.map